import { render, staticRenderFns } from "./EducationPurchaseRequestsTab.vue?vue&type=template&id=29fc0a2e&scoped=true"
import script from "./EducationPurchaseRequestsTab.vue?vue&type=script&lang=js"
export * from "./EducationPurchaseRequestsTab.vue?vue&type=script&lang=js"
import style0 from "./EducationPurchaseRequestsTab.vue?vue&type=style&index=0&id=29fc0a2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fc0a2e",
  null
  
)

export default component.exports